const projects = [
  {
    title: 'Miner\'s Park Master Plan',
    year: '2025',
    description: 'The Miner\'s Park Master Plan is a "BIG Project" aimed at reimagining Miners Park in Beaconsfield as a vibrant, welcoming space for the whole community.',
    image: '/images/miner-park-plan.jpg',
  },
];

export function ProjectsSection() {
  return (
    <section id="projects" className="py-40 px-6 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto space-y-32">
        {/* Header */}
        <div className="text-center space-y-8 animate-fade-in">
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-[0.1em] sm:tracking-[0.15em] md:tracking-[0.2em] text-secondary/80 break-words px-4">
            PROJECTS
          </h2>
        </div>

        {/* Projects Grid */}
        <div className="space-y-24">
          {projects.map((project, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-10 gap-12 items-center animate-slide-in-sequence ${
                index % 2 === 0 ? '' : 'lg:grid-flow-dense'
              }`}
              style={{ animationDelay: `${index * 200}ms` }}
            >
              {/* Text Content - 3 columns */}
              <div className={`lg:col-span-3 space-y-8 ${index % 2 === 0 ? '' : 'lg:col-start-8'}`}>
                <p className="text-xs tracking-[0.4em] text-secondary/40 uppercase">
                  {project.year}
                </p>
                
                <h3 className="text-3xl tracking-[0.2em] text-secondary/70">
                  {project.title}
                </h3>

                <p className="text-sm leading-relaxed text-white/50 tracking-wide">
                  {project.description}
                </p>

                <a 
                  href="/projects" 
                  className="inline-block text-xs tracking-[0.3em] text-secondary/60 hover:text-secondary transition-all duration-500 uppercase group"
                >
                  View Project
                  <span className="inline-block ml-2 group-hover:translate-x-2 transition-transform duration-500">→</span>
                </a>
              </div>

              {/* Image - 7 columns */}
              <div className={`lg:col-span-7 ${index % 2 === 0 ? '' : 'lg:col-start-1 lg:row-start-1'}`}>
                <div className="relative overflow-hidden aspect-[16/10] bg-black/20 group">
                  <a href="/projects">
                    <img
                        src={project.image}
                        alt={project.title}
                        className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-1000"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
